import type { Volume } from '../types/offer';
export const volumes: Volume[] = [{
  number: '1',
  title: 'THE SUNDAY LOSS',
  description: 'ব্যর্থতাকে শক্তিতে বদলানোর মনস্তত্ত্ব।',
  cover: 'https://cdn.magicpatterns.com/uploads/gieKPipiF4duEA8uQSXcdi/TOMO-1.png'
}, {
  number: '2',
  title: 'THE POTRERO SACRED CODE',
  description: 'শূন্য থেকে চ্যাম্পিয়ন হওয়ার স্ট্রিট কোড।',
  cover: 'https://cdn.magicpatterns.com/uploads/2fVkAsdribYKgenyPPfdiL/TOMO-2.png'
}, {
  number: '3',
  title: 'THE GENEALOGY OF GODS',
  description: 'বিশ্বমানের ফল দেয় যে প্রজন্মগত মানসিকতা।',
  cover: 'https://cdn.magicpatterns.com/uploads/qqDpp3AEf4dhiQCdFmspaP/TOMO-3.png'
}, {
  number: '4',
  title: 'THE PENALTY MINDSET',
  description: 'চাপের মুহূর্তে ঠান্ডা মাথায় জেতার ফ্রেমওয়ার্ক।',
  cover: 'https://cdn.magicpatterns.com/uploads/piJXrEKVGBsvgZHodV5SSH/TOMO-4.png'
}, {
  number: '5',
  title: 'TWO HEARTS, ONE BEAT',
  description: 'দুই পরিচয়কে অদম্য মানসিক দৃঢ়তায় রূপ দেওয়া।',
  cover: 'https://cdn.magicpatterns.com/uploads/4HVgZij8Trj11mizWNHdHZ/TOMO-5.png'
}, {
  number: '6',
  title: 'THE ARCHITECT LEGACY',
  description: 'নিজের সাফল্যের সিস্টেম ডিজাইন করার ব্লুপ্রিন্ট।',
  cover: 'https://cdn.magicpatterns.com/uploads/gWKLx52yPVg1KtF66eqh68/TOMO-6.png'
}];
